import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_hire_disabled_persons_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'does_facility_hire_disabled_persons_line_legal_requirements',
  name: 'Does the facility hire disabled persons in line with legal requirements?',
  description: 'Disability refers to physical, mental, sensory and / or intellectual impairments.',
  meta: {
    slcpMeta: {
      key: 'disc-4--1',
      number: 'RH-DIS-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-4--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26580,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
